import { createSelector } from 'reselect';

const notifications = state => state.notifications.list || [];

const getNewNotifCount = createSelector(notifications, notifications => notifications.filter(n => n.isNew).length);

export default {
  getNewNotifCount,
};
